import { DropDownBox, DropDownBoxLayoutStyle, DropDownBoxSearchMode } from '@apply/components';
import { useBorrowerEntitySearch } from '../../../queries/borrowerEntityQueries';

interface BorrowerEntitySearchFieldProps {
    value: number | undefined;
    onChange: (borrowerEntityId: number | undefined) => void;
    disabled: boolean;
    required: boolean;
}

/** Searches borrower entities by name or TIN. */
export const BorrowerEntitySearchField = ({ value, onChange, disabled, required }: BorrowerEntitySearchFieldProps) => {
    const dataSource = useBorrowerEntitySearch();

    return (
        <DropDownBox
            id='borrowerEntityId'
            value={value ?? null}
            onChange={(entityId: number | null) => onChange(entityId ?? undefined)}
            label='Entity'
            required={required}
            dataSource={dataSource}
            displayExpr='name'
            valueExpr='entityId'
            placeholder='Search Borrower Entities by Name or TIN...'
            searchMode={DropDownBoxSearchMode.Contains}
            // Read-only as well as disabled, so a disabled box gets DropDownBox's grey background like B-Client
            disabled={disabled}
            readOnly={disabled}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
